module.exports = __webpack_public_path__ + "img/img24.338ffe38.png";